module.exports = __webpack_public_path__ + "img/cia_logo_white.57bef5e1.svg";